var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#878787;}\r\n\t.st2{fill:#FFEC00;}\r\n\t.st3{fill:#00FFF2;}\r\n\t.st4{fill:#388E00;}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M223,213.4c0,0-3.5-15.1-1.3-15.1s43.1-7.6,40.4-27.5c0.1-18.9-6.2-27-20.5-32.6c-14.3-5.7-39.9-2.7-39.9-2.7 s-9.2-28-23.1-35.7c-13.8-10.5-51.4-7.9-67.5,3.3c-11.6,10-16.2,20.5-16.7,31.3c-10.9,0.8-35.1,0.8-44.6,28.5 c-2.6,14.4,11.5,32,30.7,33.6c19.2,1.6,9.9,13.6,9.9,13.6s-7.9,5.1-18.4,2s-35.4-13.6-41.3-32.2s3.2-35.6,11.7-43.7 s23.1-14,33.8-16c4.9-12.5,12.5-27.7,33.6-36.4s54.6-10.7,73.6-1.2s33.6,25.3,34.6,35.8c19.6,1.2,40.2,4.4,54.2,20.2 s11.9,37,5.3,47.1C270.8,195.9,257.7,213,223,213.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "64.1,229.3 93,168.1 135.6,168.1 103,214.8 131.5,214.8 81.7,271.4 91.4,229.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M129.1,256.3l25.3-77.1c0,0,3-12.1,13.2-11.1c10.2,1.1,7.6,10.5,5.1,18.3c-2.4,7.8-23.7,73.9-23.7,73.9 s-2.7,11.3-13.5,6.7C124.8,262.5,129.1,256.3,129.1,256.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M179.3,229.6l17.8-56.9c0,0,5.7-8.6,14.3-4.6c8.6,4,6.5,7.8,5.7,12.1c-0.8,4.3-16.7,52.6-16.7,52.6 s-5.7,9.2-12.7,5.4S178.7,231.4,179.3,229.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M483.1,309.2c-11.4,65.5-63.1,96.4-63.1,96.4c-19.3,13.2-42.7,20.9-67.9,20.9c-66.7,0-120.8-54.1-120.8-120.8 s54.1-120.8,120.8-120.8c0,0,48.3-7.3,93.3,44c11.1,15.1,15.6,2.9,15.6,2.9l-3.4-4.8c-24.1-32.7-63.1-53.9-107.2-53.9 c-73.3,0-132.7,58.8-132.7,131.3s59.4,131.3,132.7,131.3c36.3,0,69.2-14.5,93.2-37.9c24.4-23.8,39.5-56.9,39.5-93.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M423.6,252.5c-15.4-23-41.2-38.2-70.5-38.2c-47.1,0-85.4,39.2-85.4,87.5s38.2,87.5,85.4,87.5 c19.3,0,36.1-7.9,51.4-17.6c32.3-20.6,45.3-69,45.3-69c0,3.4-0.2,6.7-0.5,10c-5,49.1-46.4,87.4-96.8,87.4 c-53.8,0-97.3-43.6-97.3-97.3s43.6-97.3,97.3-97.3c32.9,0,62,16.3,79.6,41.3L423.6,252.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M402.1,269.7c-10.6-16.4-29.1-27.2-50-27.2c-32.9,0-59.6,26.7-59.6,59.6s26.7,59.6,59.6,59.6 c25,0,45.8-15.7,55.3-37.2c-27.2,23.2-49.8,25.6-55.5,25.6c-26.7,0-48.3-21.9-48.3-48.8s21.6-48.8,48.3-48.8c16,0,30.2,7.9,39,20 L402.1,269.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M483.2,245.2L464,216.1L364.8,286c-2.9-2.1-6.4-3.3-10.2-3.3c-9.7,0-17.5,7.8-17.5,17.5 c0,9.7,7.8,17.5,17.5,17.5c9.7,0,17.5-7.8,17.5-17.5c0-1.1-0.1-2.1-0.3-3.1L483.2,245.2z"
})));
function SvgRadar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 512,
    height: 512,
    xlinkHref: "85A0B54C.jpg",
    transform: "matrix(1 0 0 1 -4.1971 0)"
  })), _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar);
export default __webpack_public_path__ + "static/media/radar.94efbfbd48a0faa8b5a40e1899b29106.svg";
export { ForwardRef as ReactComponent };